import PropTypes from 'prop-types';

import { NAME } from '#client/build-env';
import AutoLogin from '#client/components/AutoLogin';
import ShoppingErrorBoundary from '#client/components/ShoppingErrorBoundary';
import useFlowConfig from '#client/hooks/flow/useFlowConfig';

function PostOrderLogin({ email, password }) {
  const { postOrderRedirect } = useFlowConfig();

  return (
    <ShoppingErrorBoundary
      fallback={<AutoLogin.Error email={email} />}
      id={`${NAME}/PostOrderLogin`}
    >
      <AutoLogin email={email} password={password} redirectTo={postOrderRedirect} />
    </ShoppingErrorBoundary>
  );
}

PostOrderLogin.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired
};

export default PostOrderLogin;
